<template>
    <div>
        <v-card flat class="mt-2">
            <v-form class="multi-col-validation">
                <v-card-title>Register Lanjutan PPDS</v-card-title>
                <v-card-text class="">
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="user.username" label="Username :" dense outlined readonly></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="user.email" label="Email :" dense outlined readonly></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.nama" label="Nama :" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.nim" label="NIM :" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-autocomplete v-model="userTambahan.institusi_pendidikan" :items="institusi_pendidikans"
                                outlined dense label="Institusi Pendidikan :" item-text="nama"
                                item-value="id"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-autocomplete v-model="userTambahan.prodi" :items="prodis" outlined dense label="Prodi :"
                                item-text="nama" item-value="id"></v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="6" md="3">
                            <v-select v-model="userTambahan.jenis_kelamin" outlined dense label="Jenis Kelamin :"
                                :items="['Pria', 'Wanita']"></v-select>
                        </v-col> -->
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.level" label="Level :" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
                    Upload Dokumen :
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        No
                                    </th>
                                    <th class="text-left">
                                        Nama
                                    </th>
                                    <th class="text-left">
                                        File
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dokumens" v-bind:key="item.id">
                                    <td>{{ parseInt(index) + 1 }}</td>
                                    <td>{{ item.nama }}</td>
                                    <td><upload-dokumen-registrasi :namaDokumen="item.kode"></upload-dokumen-registrasi></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-card-text>
                    <v-btn color="primary" class="me-3 mt-3" @click="simpan">
                        Simpan
                    </v-btn>
                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios'
import UploadDokumenRegistrasi from '@/components/upload/UploadDokumenRegistrasi.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        UploadDokumenRegistrasi,
    },
    data: () => ({
        userTambahan: {
            username: '',
            email: '',
            nama: '',
            nim: '',
            institusi_pendidikan: '',
            prodi: '',
            // jenis_kelamin: '',
            // alamat: '',
            level: '',
            // dokumen: [
            //     {
            //         id: 'surat_pengantar',
            //         nama: 'Surat Pengantar/surat tugas dari institusi'
            //     },
            //     {
            //         id: 'ijazah',
            //         nama: 'Ijazah (Bagi peserta didik Profesi/PPDS), Kartu Tanda Mahasiswa (KTM)/ Kartu Pelajar/ID Card/ Sejenisnya (bagi Peserta didik Vokasi / Strata)'
            //     },
            //     {
            //         id: 'str',
            //         nama: 'STR'
            //     },
            //     {
            //         id: 'sip',
            //         nama: 'SIP'
            //     },
            //     {
            //         id: 'sertifikat_kompetensi',
            //         nama: 'Sertifikat Kompetensi/ Identifikasi Level'
            //     },
            //     {
            //         id: 'klasifikasi_akademik',
            //         nama: 'Klasifikasi Akademik/ Kewenangan klinis'
            //     },
            //     {
            //         id: 'rekening_bank',
            //         nama: 'Rekening Bank (Level Hijau) Diutamakan Mandiri/ Bank Jateng'
            //     },
            //     {
            //         id: 'npwp',
            //         nama: 'NPWP (Level Hijau)'
            //     },
            //     {
            //         id: 'ktp',
            //         nama: 'KTP'
            //     },
            //     {
            //         id: 'pas_foto',
            //         nama: 'Pas Foto (background Merah)'
            //     },
            // ],
            dokumen: [],
        },
        dokumens: [],
        institusi_pendidikans: [],
        prodis: [],
    }),
    computed: {
        headers() {
            return {
                Authorization: this.$store.state.token,
            }
        },
        user() {
            return this.$store.getters.user
        },
    },
    created() {
        this.getInstitusiPendidikan()
        this.getProdi()
        this.getDokumenRequirement()
    },
    methods: {
        getDokumenRequirement() {
            let fmData = new FormData();
            fmData.append('profesi', 'PPDS')
            axiosPostAuth('api/RegisterLanjutan/getDokumenRequirement', fmData)
                .then(response => {
                    this.dokumens = Object.assign({}, response.data)
                    response.data.forEach(element => {
                        this.userTambahan.dokumen.push(element.kode)
                    });
                })
        },
        getInstitusiPendidikan() {
            const headers = this.headers
            axios
                .get(`${apiRoot}/api/RegisterLanjutan/getInstitusiPendidikans`, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.institusi_pendidikans = response.data.datas
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        getProdi() {
            // this.loading = true
            const headers = this.headers
            axios
                .get(`${apiRoot}/api/RegisterLanjutan/getProdis`, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.prodis = response.data.datas
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        simpan() {
            const headers = this.headers
            const fmData = new FormData()
            fmData.append('username', this.userTambahan.username)
            fmData.append('email', this.userTambahan.email)
            fmData.append('nama', this.userTambahan.nama)
            fmData.append('nim', this.userTambahan.nim)
            fmData.append('institusi_pendidikan', this.userTambahan.institusi_pendidikan)
            fmData.append('prodi', this.userTambahan.prodi)
            fmData.append('level', this.userTambahan.level)
            fmData.append('dokumen', this.userTambahan.dokumen)
            fmData.append('role_temp', this.user.role_temp)
            axios
                .post(`${apiRoot}/api/RegisterLanjutan/addRegistrasiPesertaPpds`, fmData, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.$store.dispatch('logout', response.data.message)
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
    },
}
</script>